<script>
export default {
  props: {
    onFleetGraphClick: {
      type: Function,
      required: true,
    },
  },
}
</script>
